module.exports = "<mat-icon svgIcon=\"dehoniane-logo\"></mat-icon>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/helpers/mat-icon-dehoniane/mat-icon-dehoniane.component.html
// module id = ./src/app/helpers/mat-icon-dehoniane/mat-icon-dehoniane.component.html
// module chunks = main